import type { RunnerId } from '@ps/isp-web-services-types';

import { initialState } from '..';
import type { BetSlipState } from '../types';

const selectionRemoved = (state: BetSlipState, payload: RunnerId): BetSlipState => {
  if (state.isLocked) {
    return state;
  }

  const filteredSelections = state.selections.filter(
    (selection) =>
      !(selection.selectionId === payload.selectionId && selection.marketId === payload.marketId)
  );

  return {
    ...state,
    selections: filteredSelections,
    selectedPromotionPicker: initialState.selectedPromotionPicker,
    ...(filteredSelections.length === 0 && {
      acceptedOdds: initialState.acceptedOdds,
      opportunities: initialState.opportunities
    })
  };
};

export default selectionRemoved;
